
import { forkJoin as observableForkJoin, Observable } from 'rxjs';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Association } from '../../../shared/models/association.model';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { FileHolder, UploadMetadata, ImageUploadComponent } from 'angular2-image-upload';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ImgCropperComponent } from './img-cropper/img-cropper.component';
import { AssociationService } from '../../../shared/services/association.service';
import { LoaderService } from '../../../shared/services/loader.service';
import { ToastyService } from 'ng2-toasty';

@Component({
  selector: 'app-association-landing',
  templateUrl: './association-landing.component.html',
  styleUrls: ['./association-landing.component.css']
})
export class AssociationLandingComponent implements OnInit {

  @ViewChild('cover', { static: true }) previewCover: ElementRef;
  @ViewChild('logo', { static: true }) previewLogo: ElementRef;

  public about: AbstractControl;
  public actions: AbstractControl;
  public editorOptions = {
    toolbar: {
      container: [
        ['bold', 'italic', 'underline', 'strike'],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        [{ 'color': [] }, { 'background': [] }],
        [{ 'font': [] }],
        [{ 'align': [] }],
        ['link'],
        ['clean']
      ]
    }
  };

  public association: Association = new Association();
  public associationDetailsForm: FormGroup;

  public imgs = new Map<string, File>();
  public isUploadDisabled = false;
  public uploadedImgs = [];
  public uploadedLogo: File;
  public uploadedCover: File;

  public hasLogo = false;
  public hasCover = false;

  private deletedFiles: number[] = [];
  private pdfDescriptif: File;
  private pdfEvent: File;

  constructor(private router: Router, private route: ActivatedRoute, private formBuilder: FormBuilder,
    public ngbmodalService: NgbModal, private service: AssociationService, private toastyService: ToastyService,
    private loaderService: LoaderService) {
    this.association = this.route.snapshot.data['association'];

    this.associationDetailsForm = formBuilder.group({
      'about': ['', [Validators.required]],
      'actions': ['', [Validators.required]],
      'video': [''],
      'video_presentation': ['']
    });

    this.about = this.associationDetailsForm.controls['about'];
    this.actions = this.associationDetailsForm.controls['actions'];
  }

  ngOnInit() {
    this.associationDetailsForm.patchValue(this.association);
    if (this.association['diaporamas']) {
      this.association['diaporamas'].forEach(img => {
        this.uploadedImgs.push({ fileName: img.id, url: img.value.url })
      });
    }

    if (this.association.banner && this.association.banner.url) {
      this.hasCover = true;
      this.previewCover.nativeElement.src = this.association.banner.url;
    }

    if (this.association.logo && this.association.logo.url) {
      this.hasLogo = true;
      this.previewLogo.nativeElement.src = this.association.logo.url;
    }
  }

  onChangeContent(input: any) {
    console.log('input', input);
  }

  onPDFFileChange(event, type: string) {
    if (event.target.files && event.target.files.length > 0) {
      if ('event' === type) {
        this.pdfEvent = event.target.files[0];
      } else {
        this.pdfDescriptif = event.target.files[0];
      }
    }
  }

  onFileUpload(input: any, fileType: string) {
    if (input.target.files && input.target.files.length > 0) {
      const modalRef = this.ngbmodalService.open(ImgCropperComponent);
      modalRef.componentInstance.img = input.target.files[0];
      modalRef.componentInstance.fileType = fileType;
      modalRef.componentInstance.ratio = 'cover' === fileType ? 2.8 : 1;

      modalRef.result.then((result) => {
        if ('modal-cancel' !== result) {
          const block = result.split(';');
          const contentType = block[0].split(':')[1];
          const fileName = input.target.files[0].name.substring(0, input.target.files[0].name.indexOf('.')) + '.jpg';
          if ('cover' === fileType) {
            this.hasCover = true;
            this.uploadedCover = new File([this.b64toBlob(block[1].split(',')[1], contentType, 512)], fileName, { type: contentType });
            this.previewCover.nativeElement.src = result;
          } else {
            this.hasLogo = true;
            this.uploadedLogo = new File([this.b64toBlob(block[1].split(',')[1], contentType, 512)], fileName, { type: contentType });
            this.previewLogo.nativeElement.src = result;
          }
        } else {
          input.target.files = null;
        }
      })
    }
  }

  onBeforeUpload = (input: UploadMetadata) => {
    const modalRef = this.ngbmodalService.open(ImgCropperComponent);
    modalRef.componentInstance.img = input.file;
    modalRef.componentInstance.fileType = 'slide';
    modalRef.componentInstance.ratio = 1.8;
    return modalRef.result.then((result) => {
      if ('modal-cancel' !== result) {
        const block = result.split(';');
        const contentType = block[0].split(':')[1];
        const fileName = input.file.name.substring(0, input.file.name.indexOf('.')) + '.jpg';
        const file = new File([this.b64toBlob(block[1].split(',')[1], contentType, 512)], fileName, { type: contentType });
        this.imgs.set(fileName, file);

        input.file = file;
        return input;
      } else {
        input.abort = true;
        return input;
      }
    });
  };

  onUploadFinished(file: FileHolder) {
    console.log('onUploadFinished', this.imgs);
    if (this.imgs.size > 2) {
      this.isUploadDisabled = true;
    }
  }

  onRemoved(input: any) {
    if (isNaN(Number(input.file.name))) {
      this.imgs.delete(input.file.name);
    } else {
      this.uploadedImgs.forEach((element, index) => {
        this.uploadedImgs.splice(index, 1);
      });
      this.deletedFiles.push(Number(input.file.name));
    }
  }

  onPreviewClicked(input: FileHolder) {
    console.log('onPreviewClicked', input)
  }

  onAssociationLandingCancel(): void {
    this.router.navigate(['/associations/list']);
  }

  onSubmit() {
    this.loaderService.show();

    const all = [];

    if (this.uploadedCover) {
      const formData: FormData = new FormData();
      formData.append('assoc[banner]',
        this.uploadedCover, this.uploadedCover.name);
      all.push(this.service.upload(this.association.id, formData, ''));
    }

    if (this.uploadedLogo) {
      const formData: FormData = new FormData();
      formData.append('assoc[logo]',
        this.uploadedLogo, this.uploadedLogo.name);
      all.push(this.service.upload(this.association.id, formData, ''));
    }

    if (this.imgs.size > 0) {
      this.imgs.forEach((value, key) => {
        const formData: FormData = new FormData();
        formData.append('diaporama[title]', key);
        formData.append('diaporama[assoc_id]', this.association.id.toString());
        formData.append('diaporama[value]', value, key);

        this.service.upload(this.association.id, formData, '/diaporama').subscribe(
          data => {
            this.toastyService.success({
              title: 'Op&eacute;ration r&eacute;ussie',
              msg: 'Le fichier [' + key + '] a &eacute;t&eacute; upload&eacute;e avec succes',
              showClose: true,
              timeout: 5000,
              theme: 'bootstrap',
            });
          },
          err => {
            this.toastyService.error({
              title: 'Attention',
              msg: 'Le fichier [' + key + '] n\'a pas &eacute;t&eacute; upload&eacute;es',
              showClose: true,
              timeout: 5000,
              theme: 'bootstrap',
            });
          },
          () => console.log('done')
        );
      });
    }

    if (this.pdfDescriptif) {
      const formData: FormData = new FormData();
      formData.append('assoc[desc_doc]',
        this.pdfDescriptif, this.pdfDescriptif.name);
      all.push(this.service.upload(this.association.id, formData, ''));
    }

    if (this.pdfEvent) {
      const formData: FormData = new FormData();
      formData.append('assoc[event_doc]',
        this.pdfEvent, this.pdfEvent.name);
      all.push(this.service.upload(this.association.id, formData, ''));
    }

    if (this.deletedFiles.length > 0) {
      this.association['deletedFiles'] = this.deletedFiles;
      all.push(this.service.update(this.association));
    }

    if (this.associationDetailsForm.dirty) {
      this.association.about = this.associationDetailsForm.value['about'];
      this.association.actions = this.associationDetailsForm.value['actions'];
      this.association.video = this.associationDetailsForm.value['video'];
      this.association.video_presentation = this.associationDetailsForm.value['video_presentation'];
      all.push(this.service.update(this.association));
    }

    observableForkJoin(all).subscribe(data => {
      this.toastyService.success({
        title: 'Op&eacute;ration r&eacute;ussie',
        msg: 'Vos modifications ont &eacute;t&eacute; sauvegard&eacute;es',
        showClose: true,
        timeout: 5000,
        theme: 'bootstrap',
      });

      this.imgs.clear();
      this.router.navigateByUrl('/associations/list');
    }, err => console.log('error', err), () => this.loaderService.hide());
  }

  /** Convert a base64 string in a Blob according to the data and contentType.
*
* @param b64Data {String} Pure base64 string without contentType
* @param contentType {String} the content type of the file i.e (image/jpeg - image/png - text/plain)
* @param sliceSize {Int} SliceSize to process the byteCharacters
* @see http://stackoverflow.com/questions/16245767/creating-a-blob-from-a-base64-string-in-javascript
* @return Blob
*/
  private b64toBlob(b64Data, contentType, sliceSize): Blob {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;

    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
  }
}
